import $ from 'jquery';
import { ev } from '../utils';

import gsap from 'gsap';

export default () => {
	const menuContainer = document.querySelector('[data-menu="container"]');
	if (!menuContainer) return;
	const menuLogo = menuContainer.querySelector('.logo-menu');
	const menuItemsBox = menuContainer.querySelector('[data-menu="itemsBox"]');
	const menuItems = menuContainer.querySelector('[data-menu="items"]');
	const $menuItem = menuContainer.querySelectorAll('[data-menu="item"]');
	const $menuLink = menuContainer.querySelectorAll('[data-menu="link"]');
	const $burgerBtn = $('[data-burger] .btn-burger');

	$('body').on('click', '[data-menu-show-culinary]', function (e) {
		const articleType = this.dataset.type;

		$burgerBtn.trigger('click', [false]);

		ev('showCulinary', { type: articleType });
	});

	$('body').on('click', '[data-menu-show-aisle]', function (e) {
		const articleType = this.dataset.type;

		$burgerBtn.trigger('click', [false]);

		ev('showAisle', { type: articleType });
	});

	const getWindowHeight = () => {
		if (document) {
			const windowHeight = document.documentElement.clientHeight;
			const vh = windowHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
			return vh * 100 - 60 + 120; // Повертаємо висоту в пікселях
		}
		return 0;
	};

	let windowHeightPx = getWindowHeight();

	window.addEventListener('resize', () => {
		windowHeightPx = getWindowHeight();
	});

	const tl = gsap.timeline();

	$menuLink.forEach((el, index) => {});
};
